import { Component, Output, EventEmitter } from '@angular/core';
import { ModalComponent } from "../../../../shared/components/modal/modal.component";
import { Router } from '@angular/router';

@Component({
  selector: 'aig-modal-new-claim',
  imports: [ModalComponent],
  templateUrl: './modal-new-claim.component.html',
  styleUrl: './modal-new-claim.component.scss'
})
export class ModalNewClaimComponent {
 
  @Output() hideNewClaimModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  clickHide(): void {
    this.hideNewClaimModal.emit(true);
  }
 
  constructor(private router: Router) {}

  public OpenNewClaim(): void{
    this.clickHide();
    this.router.navigate(['area-cliente/gestion-siniestros/nuevo']);   
  }

}
